import * as React from 'react';
import type { ReactNode } from 'react';

export enum StageRangeType {
    stage1 = 'stage1',
    stage2 = 'stage2',
    stage3 = 'stage3',
}

export interface State {
    stage: StageRangeType;
    isLogin: boolean;
}

const { createContext, useContext } = React;

const initialState = { stage: StageRangeType.stage3, isLogin: false } as State;

export const Context = createContext(initialState);
export const useContainer = () => useContext(Context);

function AppreContext({ children, value }: { children: ReactNode; value: Partial<State> }) {
    const mergedState = { ...initialState, ...value };

    return (
        <Context.Provider
            value={{
                ...mergedState,
            }}
        >
            {children}
        </Context.Provider>
    );
}

export default AppreContext;
